import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';
import { Link } from 'react-router-dom';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import TopFeatureTile from './topFeatureTile';
import { TOP_FEATURES_TITLES_CONFIG } from './topFeatures.config';
import { SeeMoreFeatures, TilesContainer } from './topFeatures.styled';

const TopFeatureTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        All-in-one <strong>booking software </strong>
        to help you
        <br />
        manage your pet business
      </h2>
    </TextWithHighlight>
  );
};

const TopFeatureSubTitle = () => {
  return (
    <p>
      Say goodbye to endless admin with a pet booking platform that takes bookings online, manages clients and more with
      no monthly fee.
    </p>
  );
};

export function TopFeatures() {
  return (
    <WidthContainer noBackground>
      <SectionContainer subTitle={TopFeatureSubTitle} title={TopFeatureTitle}>
        <TilesContainer>
          {TOP_FEATURES_TITLES_CONFIG.map((tile) => (
            <TopFeatureTile title={tile.title} description={tile.description} icon={tile.icon} />
          ))}
        </TilesContainer>

        <SeeMoreFeatures>
          Want to know more? See all <Link to="/business/features">Pata features</Link> that help pet businesses run and
          grow with ease.
        </SeeMoreFeatures>
      </SectionContainer>
    </WidthContainer>
  );
}
